export const copy = {
    addDescription: {
        PLACEHOLDER: 'Click here to edit folder description',
    },
    bulkSelect: {
        FOLDERS: 'select folders',
        ITEMS: 'select items',
    },
    addItems: {
        ERROR_DESCRIPTION: 'Sorry there was an error adding your items, please try again.',
        ERROR_TITLE: 'Error',
        EMPTY_DESCRIPTION: 'Create a folder to save your items to by clicking the button below.',
        EMPTY_TITLE: 'Organize your favorites',
        MODAL_TITLE: 'Add to Folder',
        SUBMIT: 'Save',
        SUCCESS_TITLE: 'Item(s) Added!',
        SUCCESS_DESCRIPTION: 'Your items were added successfully.',
        NULLSTATE_TITLE: 'Items Added!',
        NULLSTATE_DESCRIPTION: 'Your items were added successfully.',
    },
    addNote: {
        ERROR_DESCRIPTION: 'Sorry there was an error creating your note, please try again.',
        ERROR_TITLE: 'Error',
        MODAL_TITLE: 'Note',
        PLACEHOLDER_NOTE: 'Add a note about the item here',
        SUBMIT: 'Save',
        SUCCESS_DESCRIPTION: 'Your note was added successfully.',
        SUCCESS_TITLE: 'Note Added!',
    },
    createFolder: {
        ERROR_DESCRIPTION: 'Sorry there was an error creating your folder, please try again.',
        ERROR_TITLE: 'Error',
        MODAL_TITLE: 'Create New Folder',
        PLACEHOLDER_NAME: 'Enter folder name',
        PLACEHOLDER_DESCRIPTION: 'Enter folder description',
        SWITCH_DESCRIPTION:
            'Folders can only be viewed by others when you share them via email or url. Only you can edit your folders.',
        SWITCH_LABEL: 'Shareable:',
        SUBMIT: 'Save',
        SUCCESS_TITLE: 'Folder Created!',
        SUCCESS_DESCRIPTION: 'Your folder was created successfully.',
    },
    deleteNote: {
        DELETE: 'Delete Note',
        ERROR_DESCRIPTION: 'Sorry there was an error deleting your note, please try again.',
        ERROR_TITLE: 'Error',
        SUCCESS_DESCRIPTION: 'Your note was deleted successfully.',
        SUCCESS_TITLE: 'Note Deleted!',
    },
    bulkActions: {
        CREATE_FOLDER: 'create folder',
        CREATE_PROJECT: 'create new tag',
        SHARE: 'share folder',
        SHARE_MOBILE: 'share',
        PROCUREMENT_CTA: 'Purchasing Service',
    },
    cuttoffs: {
        FOLDER: 'Search, sort, and rearrange are disabled for folders with more than 10,000 items',
        FOLDERS: 'Sort and rearrange are disabled when you have more than 10,000 folders',
        ITEMS: 'Search, sort, and rearrange are disabled when you have more than 10,000 items',
    },
    error: {
        ERROR_HEADER: 'Sorry, an error has occurred.',
        ERROR_TEXT: 'Please try refreshing the page or navigating back to',
    },
    rearrange: {
        FOLDERS: 'Rearrange Folders',
        ITEMS: 'Rearrange Items',
    },
    removeFolders: {
        ERROR_DESCRIPTION: 'Sorry there was an error deleting your folder, please try again.',
        ERROR_TITLE: 'Error',
        MODAL_DESCRIPTION: 'Are you sure you want to delete? This can not be undone.',
        MODAL_TITLE: 'Delete Folder',
        SUCCESS_DESCRIPTION: 'Your folder was removed successfully.',
        SUCCESS_TITLE: 'Folder Removed!',
        SUBMIT: 'Yes, Delete',
    },
    removeFollowing: {
        ERROR_DESCRIPTION: 'Sorry there was an error deleting your following, please try again.',
        ERROR_TITLE: 'Error',
        MODAL_DESCRIPTION: 'Are you sure you want to remove this following from your favorites?',
        MODAL_TITLE: 'Delete Following',
        SUCCESS_DESCRIPTION: 'Your following is removed successfully!',
        SUCCESS_TITLE: 'Following Removed!',
        SUBMIT: 'Yes, Delete',
    },
    removeItems: {
        ERROR_DESCRIPTION: 'Sorry there was an error deleting your items, please try again.',
        ERROR_TITLE: 'Error',
        MODAL_DESCRIPTION: 'Are you sure you want to delete? This can not be undone.',
        MODAL_TITLE: 'Delete Item(s)',
        SUCCESS_DESCRIPTION: 'Your items were removed successfully',
        SUCCESS_TITLE: 'Items Removed!',
        SUBMIT: 'Yes, Delete',
    },
    shareFolder: {
        BUTTON_DESCRIPTION: 'Send a link by copy pasting this url:',
        BUTTON_LABEL: 'copy',
        ERROR_DESCRIPTION: 'Sorry there was an error sharing your folder, please try again.',
        ERROR_TITLE: 'Error',
        MODAL_TITLE: 'Share Folder',
        PLACEHOLDER_EMAILS: 'Enter recipient emails, separated by commas',
        PLACEHOLDER_EMAILS_MOBILE: 'Enter recipient emails',
        PLACEHOLDER_NAME: 'Enter your name',
        PLACEHOLDER_MESSAGE: 'Add a personalized message (optional)',
        PLACEHOLDER_SENDER_EMAIL: 'Enter your email',
        SHARE_INFO: 'You will receive a copy of this email.',
        SUBMIT: 'Share Folder',
        SUCCESS_DESCRIPTION: 'Your folder was shared successfully',
        SUCCESS_TITLE: 'Folder Shared!',
    },
    shareItems: {
        MODAL_TITLE: 'Share Items',
        ERROR_DESCRIPTION: 'Sorry there was an error sharing your item(s), please try again.',
        ERROR_TITLE: 'Error',
        PLACEHOLDER_EMAILS: 'Enter recipient email addresses, separated by commas',
        PLACEHOLDER_NAME: 'Enter your name',
        PLACEHOLDER_MESSAGE: 'Add a personalized message (optional)',
        PLACEHOLDER_SENDER_EMAIL: 'Enter your email',
        SHARE_INFO: 'You will receive a copy of this email.',
        SHARE_NOTES: 'Allow recipient to see your notes',
        SUBMIT: 'Share Items',
        SUCCESS_DESCRIPTION: 'Your items were shared successfully',
        SUCCESS_TITLE: 'Items Shared!',
    },
    sortBy: {
        ALPHABETICAL: 'Alphabetical',
        MODIFIED: 'Most Recent',
        CUSTOM: 'Custom Order',
        RECENTLY_CREATED: 'Most Recent',
        PRICE_ASC: 'Price (Low to High)',
        PRICE_DESC: 'Price (High to Low)',
    },
    noPermission: {
        DELETED_FOLDER_HEADER: 'Sorry, this folder is no longer available.',
        PRIVATE_FOLDER_HEADER: 'Sorry, this folder is private.',
        PRIVATE_FOLDER_PAGE_ACCESS:
            'If you know the person that created this folder, please ask them to make it shareable so that you may view it.',
    },
    recommendations: {
        FOLDER_TITLE: 'Get Organized!',
        FOLDER_DESCRIPTION:
            'Organize your items by saving them to folders. Add notes and share. Click the folder icon near any item to save it to a folder.',
        ITEMS_TITLE: 'Save what you love!',
        ITEMS_DESCRIPTION:
            "Click the heart icon near any item to save it to your favorites. We'll send updates on the pieces you love.",
        ITEMS_START: 'Start by saving some popular items',
        FOLDERS_TITLE: 'Get organized!',
        FOLDERS_DESCRIPTION:
            'Organize your items by saving them to folders. Add notes and share. Click the folder icon near any item to save it to a folder.',
        FOLLOWING_TITLE: 'Receive Customized Alerts on New Arrivals',
        FOLLOWING_DESCRIPTION:
            'When you follow dealers, creators, categories or searches, you will receive updates on relevant new arrivals via email and see those pieces here.',
        FOLLOWING_START: 'Start by Browsing Popular Searches',
        FOLLOW: 'Follow',
        PROJECT_TITLE: 'Start Tagging!',
        PROJECT_DESCRIPTION: 'All your items tagged with this project label will be stored here',
        PROJECTS_TITLE: 'Create Project Tags',
        PROJECTS_DESCRIPTION:
            'Tag items associated with a project so you can filter and organize them more easily.',
    },
    tooltips: {
        EDIT_FOLDER: {
            header: 'Edit Folder',
            text: 'Click on the pencil icon to edit the title and description of your folder',
        },
        REARRANGE_FOLDERS: {
            header: 'Rearrange Folder Order',
            text:
                'You can rearrange your folders in whatever order you like when the rearrange toggle is set to On.',
        },
        REARRANGE_ITEMS: {
            header: 'Rearrange Item Order',
            text:
                'You can rearrange your items in whatever order you like when the rearrange toggle is set to On.',
        },
        SHARE_FOLDER: {
            header: 'Share Folder',
            text:
                'Toggle your folder to "Shareable" in order to share it with others. Folders can only be viewed by those you share them with via email or url. Only you can edit your folders.',
        },
        SHARE_ITEMS: {
            header: 'Sorry',
            text:
                "We're unable to share more than 50 items. To share more than 50 items, add them to a folder and share the folder.",
        },
    },
    following: {
        PREFERENCES_TITLE: 'Communication preferences',
        PREFERENCES_TEXT: 'To manage email alerts please visit',
        FILTER_APPLIED: '[filters applied]',
        REMOVE: 'Remove',
    },
};

export const cutoffs = {
    ADDITIONAL_ITEMS: 60,
    FOLLOWING_ITEMS: 12,
    MAX_CHAR_DESCRIPTION: 500,
    MAX_CHAR_DESCRIPTION_MOBILE: 100,
    MAX_CHAR_NOTE: 250,
    MAX_CHAR_TITLE: 31,
    MAX_ITEMS: 10000,
    MAX_SHARE_ITEMS: 50,
    MOBILE_SCREEN: 568,
    MOVE_TOLERANCE: 3,
    RECOMMENDATION_ITEMS: 8,
    RESIZE_TIMEOUT: 66,
    SCROLL_HEIGHT: 400,
    SCROLL_TIMEOUT: 20,
    SCROLL_ZONE_UP: 0.1,
    SCROLL_ZONE_DOWN: 0.9,
};

export const modals = {
    ADD_ITEMS: 'addItems',
    ADD_ITEMS_REMOVE: 'addItems',
    ADD_NOTE: 'addNote',
    DELETE_NOTE: 'deleteNote',
    ERROR_SUCCESS: 'errorSuccess',
    CREATE_FOLDER: 'createFolder',
    LOAD_ADD_ITEMS: 'loadAddItems',
    REMOVE_FOLDERS: 'removeFolders',
    REMOVE_FOLLOWING: 'removeFollowing',
    REMOVE_ITEMS: 'removeItems',
    SHARE_FOLDER: 'shareFolder',
    SHARE_FOLDER_TYPE: 'folder',
    SHARE_ITEMS: 'shareItems',
    SHARE_ITEMS_TYPE: 'items',
};

export const mutations = {
    responses: {
        ERROR: 'error',
        COMPLETE: 'complete',
        LOADING: 'loading',
        NULL: 'nullState',
        SUCCESS: 'success',
    },
    types: {
        ADD: 'ADD',
        EDIT: 'EDIT',
        REMOVE: 'REMOVE',
        REORDER: 'REORDER',
        SHARE: 'SHARE',
    },
};

export const privacySettings = {
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
};

export const portfolioTypes = {
    FOLDER: 'FOLDER',
    ITEMS: 'HEART',
    PROJECT: 'PROJECT',
};

export const trackingLists = {
    ITEMS: 'Favorites|items',
    FOLDER: 'Favorites|folders',
    FOLLOWING: 'Favorites|following',
};

export const sortBy = {
    ALPHABETICAL: 'ALPHABETICAL',
    MODIFIED: 'MODIFIED',
    CUSTOM: 'CUSTOM',
    RECENTLY_CREATED: 'RECENTLY_CREATED',
    RECENTLY_MODIFIED: 'RECENTLY_MODIFIED',
    PRICE_ASC: 'PRICE_ASC',
    PRICE_DESC: 'PRICE_DESC',
};

export const tabs = {
    FOLDER: 'folder',
    FOLDERS: 'folders',
    FOLLOWING: 'following',
    ITEMS: 'items',
    PROJECT: 'project',
    PROJECTS: 'projects',
};

export const viewModes = {
    LIST: 'LIST',
    GRID: 'GRID',
};

export const slugify = (portfolioName = '', portfolioId) => {
    // Only allow dashes and alphanumeric characters in url label
    const portName = portfolioName
        .trim()
        .toLowerCase()
        .replace(/[^\w]+/gi, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');

    if (portName) {
        return `/${tabs.FOLDERS}/${portName}/${portfolioId}/`;
    }

    return `/${tabs.FOLDERS}/${portfolioId}/`;
};

export const deviceTypes = {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    MOBILE: 'mobile',
};

export const tooltips = {
    EDIT_FOLDER: 'editFolder',
    REARRANGE_ITEMS: 'rearrangeItems',
    SELECT_ITEMS: 'selectItems',
    SHARE_FOLDER: 'shareFolder',
    SHARE_ITEMS: 'shareItems',
};

export const followingTypes = {
    SEARCH: 'SEARCH',
    SELLER: 'SELLER',
    DESIGNER: 'DESIGNER',
    USER_PREFERENCE: 'USER_PREFERENCE',
};

export const favoriteParameters = {
    // Parameter Keys
    keys: {
        KEY_QUERY: 'query',
        KEY_CATEGORY: 'category',
        KEY_CATEGORY_L2: 'category_l2',
        KEY_PRICE: 'price',
        KEY_CURRENCY: 'currency',
        KEY_PERIOD: 'period',
        KEY_CREATOR: 'creator',
        KEY_LOCATION: 'location',
        KEY_ASSOCIATION: 'association',
        KEY_COLLECTION: 'collection',
        KEY_HEIGHT: 'height',
        KEY_WIDTH: 'width',
        KEY_LENGTH: 'length',
        KEY_SECTION_FURNITURE: 'furniture_section',
        KEY_SECTION_FASHION: 'fashion_section',
        KEY_SECTION_JEWELRY: 'jewelry_section',
        KEY_GENDER: 'gender',
        KEY_ORIGIN: 'origin',
        KEY_MATERIAL: 'material',
        KEY_METAL: 'metal',
        KEY_DEALER: 'dealer',
        KEY_SHIPPING: 'shipping',
        KEY_SOLD: 'sold',
        KEY_STONE: 'stone',
        KEY_STYLE: 'style',
        KEY_TECHNIQUE: 'technique',
        KEY_ITEM_COUNT: 'item_count',
        KEY_NEW_ITEM_COUNT: 'new_item_count',
        KEY_COLOR: 'color',
        KEY_STONE_CUT: 'stone-cut',
    },
    // Parameter Display Text
    displays: {
        DISPLAY_QUERY: 'Search Term',
        DISPLAY_CATEGORY: 'Category',
        DISPLAY_PRICE: 'Price',
        DISPLAY_CURRENCY: 'Currency',
        DISPLAY_PERIOD: 'Period',
        DISPLAY_CREATOR: 'Creator',
        DISPLAY_LOCATION: 'Location',
        DISPLAY_ASSOCIATION: 'Association',
        DISPLAY_COLLECTION: 'Collection',
        DISPLAY_HEIGHT: 'Height',
        DISPLAY_WIDTH: 'Width',
        DISPLAY_LENGTH: 'Length',
        DISPLAY_SECTION_FURNITURE: 'Section',
        DISPLAY_SECTION_FASHION: 'Section',
        DISPLAY_SECTION_JEWELRY: 'Section',
        DISPLAY_GENDER: 'Gender',
        DISPLAY_ORIGIN: 'Origin',
        DISPLAY_MATERIAL: 'Material',
        DISPLAY_METAL: 'Metal',
        DISPLAY_DEALER: 'Dealer',
        DISPLAY_SHIPPING: 'Shipping',
        DISPLAY_SOLD: 'Show Sold',
        DISPLAY_STONE: 'Stone',
        DISPLAY_STYLE: 'Style',
        DISPLAY_TECHNIQUE: 'Technique',
        DISPLAY_NEW_ITEMS: 'New Items',
        DISPLAY_COLOR: 'Color',
        DISPLAY_STONE_CUT: 'Stone Cut',
    },
};

export const favoriteParametersMapping = {
    // Parameters lists
    lists: {
        // Keys whose values are numeric ranges
        NUMERIC_RANGE_KEYS: [
            favoriteParameters.keys.KEY_PRICE,
            favoriteParameters.keys.KEY_HEIGHT,
            favoriteParameters.keys.KEY_WIDTH,
        ],
        // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
        // Categories that use length instead of height for dimensions
        SHOW_LENGTH_CATEGORIES: ['Rugs and Carpets', 'Rugs'],
        // Keys with values that need to be pre-processed
        PRE_PROCESS_KEYS: [favoriteParameters.keys.KEY_SOLD],
    },
    // Map key to display text
    DISPLAY_MAP: {
        [favoriteParameters.keys.KEY_QUERY]: favoriteParameters.displays.DISPLAY_QUERY,
        [favoriteParameters.keys.KEY_CATEGORY]: favoriteParameters.displays.DISPLAY_CATEGORY,
        [favoriteParameters.keys.KEY_PRICE]: favoriteParameters.displays.DISPLAY_PRICE,
        [favoriteParameters.keys.KEY_CURRENCY]: favoriteParameters.displays.DISPLAY_CURRENCY,
        [favoriteParameters.keys.KEY_PERIOD]: favoriteParameters.displays.DISPLAY_PERIOD,
        [favoriteParameters.keys.KEY_CREATOR]: favoriteParameters.displays.DISPLAY_CREATOR,
        [favoriteParameters.keys.KEY_LOCATION]: favoriteParameters.displays.DISPLAY_LOCATION,
        [favoriteParameters.keys.KEY_ASSOCIATION]: favoriteParameters.displays.DISPLAY_ASSOCIATION,
        [favoriteParameters.keys.KEY_COLLECTION]: favoriteParameters.displays.DISPLAY_COLLECTION,
        [favoriteParameters.keys.KEY_HEIGHT]: favoriteParameters.displays.DISPLAY_HEIGHT,
        [favoriteParameters.keys.KEY_WIDTH]: favoriteParameters.displays.DISPLAY_WIDTH,
        [favoriteParameters.keys.KEY_LENGTH]: favoriteParameters.displays.DISPLAY_LENGTH,
        [favoriteParameters.keys.KEY_SECTION_FURNITURE]:
            favoriteParameters.displays.DISPLAY_SECTION_FURNITURE,
        [favoriteParameters.keys.KEY_SECTION_FASHION]:
            favoriteParameters.displays.DISPLAY_SECTION_FASHION,
        [favoriteParameters.keys.KEY_SECTION_JEWELRY]:
            favoriteParameters.displays.DISPLAY_SECTION_JEWELRY,
        [favoriteParameters.keys.KEY_GENDER]: favoriteParameters.displays.DISPLAY_GENDER,
        [favoriteParameters.keys.KEY_ORIGIN]: favoriteParameters.displays.DISPLAY_ORIGIN,
        [favoriteParameters.keys.KEY_MATERIAL]: favoriteParameters.displays.DISPLAY_MATERIAL,
        [favoriteParameters.keys.KEY_METAL]: favoriteParameters.displays.DISPLAY_METAL,
        [favoriteParameters.keys.KEY_DEALER]: favoriteParameters.displays.DISPLAY_DEALER,
        [favoriteParameters.keys.KEY_SHIPPING]: favoriteParameters.displays.DISPLAY_SHIPPING,
        [favoriteParameters.keys.KEY_SOLD]: favoriteParameters.displays.DISPLAY_SOLD,
        [favoriteParameters.keys.KEY_STONE]: favoriteParameters.displays.DISPLAY_STONE,
        [favoriteParameters.keys.KEY_STYLE]: favoriteParameters.displays.DISPLAY_STYLE,
        [favoriteParameters.keys.KEY_TECHNIQUE]: favoriteParameters.displays.DISPLAY_TECHNIQUE,
        [favoriteParameters.keys.KEY_NEW_ITEM_COUNT]: favoriteParameters.displays.DISPLAY_NEW_ITEMS,
        [favoriteParameters.keys.KEY_COLOR]: favoriteParameters.displays.DISPLAY_COLOR,
        [favoriteParameters.keys.KEY_STONE_CUT]: favoriteParameters.displays.DISPLAY_STONE_CUT,
    },
    PRE_PROCESS_DISPLAY_MAP: {
        true: 'Yes',
        false: 'No',
    },
};
